import { CalendarView } from '@app/components/Calendars/components';
import { useMonthlyCalendar } from '@app/components/Calendars/MonthlyCalendar/hooks';
import type { NCalendars } from '@app/components/Calendars/types';

export const MonthlyCalendar: NCalendars.MonthlyCalendarType = () => {
  const {
    toPrevMonth,
    toNextMonth,
    dayNumbers,
    openPreviewTaskModal,
    createTaskForRange,
    isLoading,
  } = useMonthlyCalendar();
  return (
    <CalendarView
      type="monthly"
      dayHumbers={dayNumbers}
      toPrevDate={toPrevMonth}
      toNextDate={toNextMonth}
      createTaskForRange={createTaskForRange}
      openPreviewTaskModal={openPreviewTaskModal}
      isLoading={isLoading}
      className="monthly-calendar"
    />
  );
};
